import { MutableState, Tools } from 'final-form'

export const changeFields = <FormValues = Record<string, any>, InitialFormValues = Partial<FormValues>>(
  [fields]: Array<Array<{ name: string; value: any }>>,
  state: MutableState<FormValues, InitialFormValues>,
  { changeValue }: Tools<FormValues, InitialFormValues>
) => {
  fields.forEach((field) => {
    changeValue(state, field.name, () => field.value)
  })
}
